import { ContactFormType } from 'components/Pages/ClaimsAndReturns/Contact/contactFormMeta';
import { ClaimProductsFormType, ReturnProductsFormType } from 'types/form';
import { StateCreator } from 'zustand';

export type ClaimsAndReturnsFlowType = 'claim' | 'return';
export type ClaimsAndReturnsStepType = 'products' | 'contact';

export type ReturnDraftType = {
    currentStep: ClaimsAndReturnsStepType;
    products: ReturnProductsFormType | null;
    contact: ContactFormType | null;
};

export type ClaimDraftType = {
    currentStep: ClaimsAndReturnsStepType;
    products: ClaimProductsFormType | null;
    contact: ContactFormType | null;
};

export type ClaimsAndReturnsSlice = {
    returnDraftsByOrderHash: Partial<Record<string, ReturnDraftType>>;
    claimDraftsByOrderHash: Partial<Record<string, ClaimDraftType>>;
    updateReturnDraft: (orderHash: string, value: Partial<ReturnDraftType>) => void;
    updateClaimDraft: (orderHash: string, value: Partial<ClaimDraftType>) => void;
    clearReturnDraft: (orderHash: string) => void;
    clearClaimDraft: (orderHash: string) => void;
};

const createEmptyReturnDraft = (): ReturnDraftType => ({
    currentStep: 'products',
    products: null,
    contact: null,
});

const createEmptyClaimDraft = (): ClaimDraftType => ({
    currentStep: 'products',
    products: null,
    contact: null,
});

export const createClaimsAndReturnsSlice: StateCreator<ClaimsAndReturnsSlice> = (set) => ({
    returnDraftsByOrderHash: {},
    claimDraftsByOrderHash: {},

    updateReturnDraft: (orderHash, value) => {
        set((state) => ({
            returnDraftsByOrderHash: {
                ...state.returnDraftsByOrderHash,
                [orderHash]: {
                    ...createEmptyReturnDraft(),
                    ...state.returnDraftsByOrderHash[orderHash],
                    ...value,
                },
            },
        }));
    },

    updateClaimDraft: (orderHash, value) => {
        set((state) => ({
            claimDraftsByOrderHash: {
                ...state.claimDraftsByOrderHash,
                [orderHash]: {
                    ...createEmptyClaimDraft(),
                    ...state.claimDraftsByOrderHash[orderHash],
                    ...value,
                },
            },
        }));
    },

    clearReturnDraft: (orderHash) => {
        set((state) => {
            const nextDrafts = { ...state.returnDraftsByOrderHash };
            delete nextDrafts[orderHash];

            return { returnDraftsByOrderHash: nextDrafts };
        });
    },

    clearClaimDraft: (orderHash) => {
        set((state) => {
            const nextDrafts = { ...state.claimDraftsByOrderHash };
            delete nextDrafts[orderHash];

            return { claimDraftsByOrderHash: nextDrafts };
        });
    },
});
